import createDOMPurify from 'dompurify';

// Own instance, string input/output only: no IN_PLACE, custom elements or hooks.
const purifier = createDOMPurify(window);
export function sanitizeHtml(value) {
  return purifier.sanitize(String(value ?? ''), {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'option', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['srcdoc'],
    SANITIZE_NAMED_PROPS: true,
    ALLOW_UNKNOWN_PROTOCOLS: false,
  });
}
export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
export function renderHtmlTemplate(template, values, htmlKeys = []) {
  const html = String(template ?? '').replace(/{{\s*(\w+)\s*}}/g, (_, key) => {
    const value = Object.hasOwn(values, key) ? values[key] : '';
    return htmlKeys.includes(key) ? sanitizeHtml(value) : escapeHtml(value);
  });
  return sanitizeHtml(html);
}
function update(el, binding) {
  el.innerHTML = sanitizeHtml(binding.value);
}
export const safeHtmlDirective = { mounted: update, updated: update };
